import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import ProfileSwitchPage from '../pages/ProfileSwitchPage';
import NewProfilePage from '../pages/Welcome/NewProfilePage';

import SignUpPage from '../pages/Welcome/SignUpPage';
import LoginPage from '../pages/Welcome/LoginPage';
import DashboardPage from '../pages/Dashboard/DashboardPage';
import ConfigPage from '../pages/Config/ConfigPage';
import NewStudentPage from '../pages/Student/NewStudentPage';
import StudentListingPage from '../pages/Student/StudentListingPage';
import EnterMarksPage from '../pages/Academics/EnterMarksPage';
import OrganiseMarksPage from '../pages/Academics/OrganiseMarksPage';
import ReportsPage from '../pages/Academics/ReportsPage';
import ReportViewerPage from '../pages/Academics/ReportViewerPage';
import FinderPage from '../pages/FinderPage';
import StudentProfilePage from '../pages/Student/StudentProfilePage';
import NewStaffPage from '../pages/Staff/NewStaffPage';
import StaffListingPage from '../pages/Staff/StaffListingPage';
import StaffProfilePage from '../pages/Staff/StaffProfilePage';
import NoAccessPage from '../pages/NoAccessPage';
import NoDataPage from '../pages/NoDataPage';
import MarksheetPage from '../pages/Academics/MarksheetPage';
import FeesBalancePage from '../pages/Student/FeesBalancePage';
import EditStudentPage from '../pages/Student/EditStudentPage';
import ResetPasswordPage from '../pages/Welcome/ResetPasswordPage';
import ForgotPasswordPage from '../pages/Welcome/ForgotPasswordPage';
import StudentTransferPage from '../pages/Student/StudentTransferPage';
import ContactCenterPage from '../pages/Student/ContactCenterPage';


const SystemRoutes = () => {


    return (
      <Router>
      <Routes>
        <Route path="/login" exact element={<LoginPage />} />
        <Route path="/" exact element={<LoginPage />} />
        <Route path="/signup" exact element={<SignUpPage />} />
        <Route path="/forgot-password" exact element={<ForgotPasswordPage />} />
        <Route path="/reset-password" exact element={<ResetPasswordPage />} />

        <Route path="/access-denied" exact element={<NoAccessPage />} />
        <Route path="/switch" element={<ProfileSwitchPage />} />
        <Route path="/profile-create" element={<NewProfilePage />} />
        <Route path="/settings" element={<ProtectedRoute element={ConfigPage} permissionCode={['MANAGE_SETTINGS']} />} />
        <Route path="/dashboard" element={<ProtectedRoute element={DashboardPage} />} />
        <Route path="/student-new" element={<ProtectedRoute element={NewStudentPage} permissionCode={['NEW_STUDENT']}/>} />
        <Route path="/student-edit" element={<ProtectedRoute element={EditStudentPage} permissionCode={['NEW_STUDENT']}/>} />
        <Route path="/student-list" element={<ProtectedRoute element={StudentListingPage} permissionCode={['VIEW_STUDENTS_LIST']}/>} />
        <Route path="/student-contacts" element={<ProtectedRoute element={ContactCenterPage} permissionCode={['CONTACT_CENTER']}/>} />


        {/** Academics */}
        <Route path="/academics-marks-entry" element={<ProtectedRoute element={EnterMarksPage} permissionCode={['ENTER_MARKS', 'SUPER_MARKS_ENTRY']} />} />
        <Route path="/academics-marks-organise" element={<ProtectedRoute element={OrganiseMarksPage} permissionCode={['ORGANISE_MARKS']} />} />
        <Route path="/academics-reports" element={<ProtectedRoute element={ReportsPage} permissionCode={['REPORT_CARDS_LIST']} />} />
        <Route path="/academics-report-view" element={<ProtectedRoute element={ReportViewerPage} permissionCode={['GENERATE_REPORT_CARDS']} />} />
        <Route path="/academics-marksheet" element={<ProtectedRoute element={MarksheetPage} permissionCode={['GENERATE_MARKSHEET']} />} />


        {/** Utility */}
        <Route path="/finder" element={<ProtectedRoute element={FinderPage} permissionCode={['FIND_STUDENT', 'FIND_STAFF', 'GENERATE_REPORT_CARDS', 'GENERATE_MARKSHEET']} />} />

        {/** Student */}
        <Route path="/student-profile" element={<ProtectedRoute element={StudentProfilePage} permissionCode={['STUDENT_PROFILE']} />} />


        {/** Staff */}
        <Route path="/staff-new" element={<ProtectedRoute element={NewStaffPage} permissionCode={['NEW_STAFF']}/>} />
        <Route path="/staff-list" element={<ProtectedRoute element={StaffListingPage} permissionCode={['VIEW_STAFF_LIST']}/>} />
        <Route path="/staff-profile" element={<ProtectedRoute element={StaffProfilePage} permissionCode={['STAFF_PROFILE']}/>} />

        {/** Fees balance */}
        <Route path="/fees-balances" element={<ProtectedRoute element={FeesBalancePage} permissionCode={['STUDENT_FEES_BALANCE']}/>} />

        {/** tools */}
          <Route path="/tools-transfer" element={<ProtectedRoute element={StudentTransferPage} permissionCode={['ORGANISE_MARKS']} />} />



        {/** Catch all for 404 */}
        <Route path="*" element={<ProtectedRoute element={NoDataPage} />} />


        


     

        
        

        {/* <Route component={NotFound} /> */}
      </Routes>
    </Router>
    );
};

export default SystemRoutes;